/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import AppointmentBookingStateTextWithIcon from 'DesignSystem/AppointmentBookingStateTextWithIcon/index'
import AppointmentCard from 'DesignSystem/AppointmentCard/index'
import BottomAction from './BottomAction/index'
import EditAction from './EditAction/index'
import Interval from './Interval/index'
import Name from './Name/index'
import React from 'react'
import Time from './Time/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Appointment({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Appointments/TabContent/Content/AppointmentsList/Content/Appointment"
  
}) {
let eventAppointmentTypeColorIdValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'appointment.type.color_id',
format: fromFormat.appointmentTypeColor,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let eventAppointmentBooking0StateValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].state',
})
let eventAppointmentBooking0ConfirmationStatusValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].confirmation_status',
})
  return (<React.Fragment
>
<AppointmentCard
  viewPath={`${viewPath}/AppointmentCard`}
 data="event.appointment.type.color_id"
 format="/Data/format.js appointmentTypeColor"
 appointmentColor={eventAppointmentTypeColorIdValueData}
>
{childProps => (
<React.Fragment>
<Interval
{...childProps}
  viewPath={`${viewPath}/Interval`}
/>
<div
  data-testid="Appointment.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Appointment.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<AppointmentBookingStateTextWithIcon
  viewPath={`${viewPath}/AppointmentBookingStateTextWithIcon`}
 data="event.appointment.booking.[0].state"
 state={eventAppointmentBooking0StateValueData}
 data="event.appointment.booking.[0].confirmation_status"
 confirmation_status={eventAppointmentBooking0ConfirmationStatusValueData}
 show_icon={true}
 size="tiny"
/>
</div>
<EditAction
  viewPath={`${viewPath}/EditAction`}
/>
</div>
<div
  data-testid="Appointment.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-1-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal2}`}
>
<Time
  viewPath={`${viewPath}/Time`}
/>
<BottomAction
  viewPath={`${viewPath}/BottomAction`}
/>
</div>
</React.Fragment>
)}
</AppointmentCard>
{children}
</React.Fragment>)
}